import { useEffect } from 'react'

/**
 * Custom hook for global app configuration
 * Handles global event listeners and app-wide settings
 */
export function useGlobalConfig() {
  useEffect(() => {
    // Global mouse event handlers to prevent multiple clicks
    const handleMouseEvents = event => {
      if (event.detail > 1) {
        event.preventDefault()
        event.stopPropagation()
      }
    }

    // Add global event listeners
    window.addEventListener('mousedown', handleMouseEvents, true)
    window.addEventListener('click', handleMouseEvents, true)

    // Cleanup function
    return () => {
      window.removeEventListener('mousedown', handleMouseEvents, true)
      window.removeEventListener('click', handleMouseEvents, true)
    }
  }, [])

  return {
    // Can be extended with other global config utilities
  }
}

export default useGlobalConfig
